const parseFileName = (url: string): string => {
  const fileName = url.slice(url.lastIndexOf('/') + 1);
  const dotIndex = fileName.lastIndexOf('.');
  const fileExtension = dotIndex !== -1 ? fileName.slice(dotIndex + 1) : '';
  const nameWithoutExt = dotIndex !== -1 ? fileName.slice(0, dotIndex) : fileName;

  const underscoreIndex = nameWithoutExt.lastIndexOf('_');
  const nameWithExt =
    fileName.slice(0, underscoreIndex) + (fileExtension ? `.${fileExtension}` : '');

  return nameWithExt;
};
export default parseFileName;
